<script setup lang="ts">
/** Five ways to fight: the modes as tall painted tiles, swipeable on a phone, five across on a desktop. Each turns to its chart (`ModeTile.vue`). */
import { useI18n } from '@/i18n';

import { MODES } from '../landing-content';
import ModeTile from './ModeTile.vue';
import SectionShell from './SectionShell.vue';

const { t } = useI18n();
</script>

<template>
  <SectionShell id="modes" icon="flag" :title="t('landing.modes.title')" :line="t('landing.modes.line')" backdrop="/art/mode-encounter.webp" wide>
    <ul class="row" data-slam="rise">
      <li v-for="m in MODES" :key="m.id" class="slot"><ModeTile :mode="m" /></li>
    </ul>
  </SectionShell>
</template>

<style scoped>
.row {
  display: flex;
  gap: 16px;
  margin: 0;
  padding: 12px clamp(14px, 4vw, 40px) 22px;
  list-style: none;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  overscroll-behavior-x: contain;
}

.row::-webkit-scrollbar {
  display: none;
}

.slot {
  flex: 0 0 min(66vw, 300px);
  height: clamp(380px, 62dvh, 480px);
  scroll-snap-align: center;
}

@media (min-width: 1100px) {
  .row {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    overflow: visible;
    padding-inline: clamp(24px, 3vw, 48px);
  }

  .slot {
    height: 460px;
  }
}
</style>
